import { render, staticRenderFns } from "./StatsTeam.vue?vue&type=template&id=148485a0&scoped=true&lang=html&"
import script from "./StatsTeam.vue?vue&type=script&lang=coffee&"
export * from "./StatsTeam.vue?vue&type=script&lang=coffee&"
import style0 from "./StatsTeam.vue?vue&type=style&index=0&id=148485a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148485a0",
  null
  
)

component.options.__file = "StatsTeam.vue"
export default component.exports